import { useFormik } from "formik";
import { isValidPhoneNumber } from 'libphonenumber-js';
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import * as Yup from "yup";
import {
  filterIncompleteCommunityList,
  newFunctionTest
} from "../helpers";
import { generateToken } from "../notifications/firebase";
import { fcmHandler } from "../store/FCMSlice";
import { clearAllRanges } from "../store/ammenitiesRangeSlice";
import {
  activeCommunity,
  login,
  logout,
  setCommunitiesList,
  setIsSkip,
  setIsWaitListVerified,
  setPendingCommunityList,
  setWaitListData
} from "../store/authSlice";
import { loadingHandler } from "../store/loadingSlice";
import useApi from "./useApi";
import useLoader from "./useLoader";
import { Appversion } from "../data/index";

import { setBeneficiary } from "../store/beneficiarySlice";

const useLogin = () => {
  const { FCMReducer } = useSelector(state => state);
  console.log("FCMReducer", FCMReducer);
  const api = useApi();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { loading, setLoading } = useLoader();
  const { deviceToken } = useSelector((state) => state?.FCMReducer);
  const [error, setError] = useState(false);
  const [logoutLoader, setLogoutLoader] = useState(false);
  const phoneRegExp = /^(\(\+\d{1,3}\))?\s?\d{10}$/;

  const notificationHandler = async () => {
    const token = await generateToken();
    await dispatch(fcmHandler(token));
    return token
  }

  const form = useFormik({
    initialValues: {
      code: "+92",
      phoneNumber: "",
      password: "",
      version: "v1.1.1"
    },
    isInitialValid: false,
    validateOnChange: true,
    validationSchema: Yup.object().shape({
      phoneNumber: Yup.string()
        .required('Phone number is required')
        .test('is-valid-phone', 'Invalid Phone Number', (value) => {
          return isValidPhoneNumber(value || '');
        }),
      password: Yup.string().required("Password is required"),
    }),
    onSubmit: async (values, { resetForm }) => {
      dispatch(loadingHandler(true));



      const deviToken = await notificationHandler();

      api
        .login({
          ...values,
          phoneNumber: values?.phoneNumber?.slice(3),
          countryCode: values?.phoneNumber?.slice(0, 3),
          deviceToken: deviToken,
          version: Appversion
        })
        .then((response) => {
          if (response?.data?.headers?.code === 200) {
            // let filteredCommunities = response?.data?.body?.communityDetail?.filter(
            //   role =>
            //      role.roleName !== 'QP_CB_User' &&
            //     !(role.isSuperUser === true && role.dbSubscription == null)
            // );

            let filteredCommunities = response?.data?.body?.communityDetail?.filter(role =>
              role.roleName === 'QP_CB_User' || !(role.isSuperUser === true && role.dbSubscription == null)
            );

            dispatch(login({ ...response?.data?.body, communityDetail: filteredCommunities }));
            // dispatch(
            //   activeCommunity(
            //     newFunctionTest(
            //       response?.data?.body?.communityDetail
            //     )
            //   )
            // );

            dispatch(
              activeCommunity(
                newFunctionTest(
                  // response?.data?.body?.communityDetail
                  filteredCommunities
                )
              )
            );
            dispatch(setBeneficiary(null))
            dispatch(setIsWaitListVerified(response?.data?.body?.isWaitListVerified));
            dispatch(setWaitListData({
              waitListPosition: response?.data?.body?.waitListDetail?.waitListPosition,
              totalWaitListUsers: response?.data?.body?.waitListDetail?.totalWaitListUsers,
            }));
            // dispatch(setCommunitiesList(editResidenceCommunityList(response?.data?.body?.communityDetail)));
            // dispatch(setCommunitiesList(filterQPCompany(response?.data?.body?.communityDetail)));

            dispatch(setCommunitiesList(filteredCommunities));
            // dispatch(setCommunitiesList(response?.data?.body?.communityDetail));

            dispatch(
              setPendingCommunityList(
                filterIncompleteCommunityList(
                  response?.data?.body?.communityDetail
                ) || null
              )
            );
            dispatch(setIsSkip(true));


            toast.success("User Logged In Successfully");
          } else {
            toast.error(response?.data?.headers?.msg);
          }
        })
        .finally(() => {
          dispatch(loadingHandler(false));
        });
    },
  });

  const logoutHandler = () => {
    setLogoutLoader(true);
    api
      .logout(deviceToken)
      .then((response) => {
        if (response?.data?.headers?.code === 200) {
          dispatch(logout());
          dispatch(clearAllRanges());
          // dispatch(fcmHandler(""));
          toast.success("User Logged Out Successfully");
        } else {
          toast.error(response?.data?.headers?.msg);
        }
      })
      .finally(() => {
        setLogoutLoader(false)
      });
  }

  return {
    form,
    error,
    logoutHandler,
    logoutLoader,
  };
};

export default useLogin;
